module.exports = {"320115001":"东山街道","320115002":"秣陵街道","320115003":"汤山街道","320115004":"淳化街道","320115005":"禄口街道","320115006":"江宁街道","320115007":"谷里街道","320115008":"湖熟街道","320115009":"横溪街道","320115010":"麒麟街道","320115401":"青龙山林场","320115402":"江宁开发区","320115403":"江宁滨江开发区","320115404":"江宁高新技术产业园","320115405":"麒麟科技创新园（生态科技城）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320115.json
// module id = 834
// module chunks = 0